import axios from 'axios';
import { clearStoredSession, getSessionToken } from '../features/auth/auth.storage';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export const httpClient = axios.create({
  baseURL: API_BASE_URL,
});

httpClient.interceptors.request.use((config) => {
  const token = getSessionToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      clearStoredSession();
      window.dispatchEvent(new Event('mifvpn:auth:unauthorized'));
    }

    return Promise.reject(error);
  },
);
